// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__Y2KKr","size-S":"Form_size-S__gauX1","size-M":"Form_size-M__cPiYv","size-L":"Form_size-L__9RP7m"};